// src/components/RedirectToExternal.jsx
import { useEffect } from 'react';

export default function RedirectToExternal({ url }) {
  // leave no history entry so Back returns to the page the user came from
  useEffect(() => window.location.replace(url), [url]);
  return null; // nothing is rendered
}
// Usage example:
// <RedirectToExternal url="https://example.com" />
// This component can be used to redirect users to an external URL without leaving a history entry.